import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { getFilteredTypes } from 'Services/GraphFilterUtils';
import ColorService from 'Services/ColorService';
import withFilterData from './withFilterData';
import { setTypeFilters, updateTypeFilter, updateTypeFilters } from 'Actions/graphFilter';
import { store } from '~/Store';
import { TYPE } from 'Types';
import { DisabledTypes } from 'Model';
import FilterHeader from './FilterHeader';
import FilterBody from './FilterBody';
import GraphFilterItem from './GraphFilterItem';
import tabStyles from './tabStyles';

const typeFilterSelector = createSelector(
  (state) => state.graphFilter.typeFilters,
  _.values
);

const GraphFilterTypes = ({ items }) => {
  const dispatch = useDispatch();
  const typeFilters = useSelector(typeFilterSelector);

  const [filterValue, setFilterValue] = useState("");
  const [configNode, setConfigNode] = useState(undefined);

  useEffect(() => {
    (async () => {
      const sorted = _.sortBy(items, [(item) => item.label.toLowerCase()])
      dispatch(setTypeFilters(_.keyBy(sorted, 'id')));
      const loadConfigNode = async () => {
        const config = await DisabledTypes.load();
        setConfigNode(config);
      };
      await loadConfigNode();
    })()
  }, [items]);

  const CellRenderItem = ({ item, ...props }) => {
    const { explore: { disabledTypes } } = store.getState();
    const color = ColorService.getColorForType(item.id);
    const enableByDefault = !disabledTypes.includes(item.id);

    const itemProps = {
      color,
      itemType: TYPE,
      enabled: item.enabled,
      value: item.id,
      label: item.label,
      enableByDefault,
      ...props
    };

    return <GraphFilterItem {...itemProps} />;
  };

  return (
    <div style={tabStyles}>
      <FilterHeader
        updateFilters={updateTypeFilters}
        items={typeFilters}
        idField="id"
        onFilter={setFilterValue}
      />
      <FilterBody
        configNode={configNode}
        items={typeFilters}
        idField="id"
        filterValue={filterValue}
        updateFilter={updateTypeFilter}
        CellRenderItem={CellRenderItem}
      />
    </div>
  );
};

export default withFilterData(GraphFilterTypes, getFilteredTypes, typeFilterSelector);
